import api from 'Application/api/api';

const getEmployeeTasksProgress = (id, cancelToken = null) =>
    api.get(`/employees/${id}/tasks-progress`, {
        cancelToken,
    });

export default getEmployeeTasksProgress;
